import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menuItem: [
    {
      access: true,
      active: true,
      icon: "user",
      title: "User",
      key: "User",
      subMenu: [
        {
          access: true,
          active: true,
          icon: "dashboard",
          key: "dashboard",
          path: "dashboard",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Dashboard",
        },
        {
          access: true,
          active: true,
          icon: "people",
          key: "userList",
          path: "userList",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Users List",
        },
        {
          access: true,
          active: false,
          icon: "settings",
          key: "userquestion_history",
          path: "userquestion_history",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Users Question History",
        },
        {
          access: true,
          active: false,
          icon: "form_list",
          key: "user_form_list",
          path: "user_form_list",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [],
          title: "User Form List",
        },
        {
          access: true,
          active: false,
          icon: "user_metrics",
          key: "user_metrics",
          path: "user_metrics",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [],
          title: "User Metrics",
        },
        {
          access: true,
          active: false,
          icon: "list",
          key: "recommendation",
          path: "recommendation",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [],
          title: "User Preference Master",
        },
        {
          access: true,
          active: false,
          icon: "travel_type",
          key: "travel_types",
          path: "travel_types",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [],
          title: "User Travel Preference Master",
        },
        {
          access: true,
          active: false,
          icon: "master_tags",
          key: "master_tags",
          path: "master_tags",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [],
          title: "Tag Master",
        },
      ],
    },
    {
      access: true,
      active: false,
      icon: "CMS",
      title: "CMS",
      key: "cms",
      subMenu: [
        {
          access: true,
          active: false,
          icon: "CMS_HOME",
          key: "cms",
          path: "cms",
          title: "Homepage Settings",
        },
        {
          access: true,
          active: false,
          icon: "Category",
          key: "category",
          path: "category",
          title: "Category Master",
        },
        {
          access: true,
          active: false,
          icon: "Recommended",
          key: "Recommended_destination",
          path: "recommendated_destination",
          title: "Recommended Destination",
        },
        {
          access: true,
          active: false,
          icon: "Trending",
          key: "trending_destination",
          path: "trending_destination",
          title: "Trending Destination",
        },
      ],
    },
    {
      access: true,
      active: false,
      icon: "subscription",
      title: "Subscription",
      key: "subscription",
      subMenu: [
        {
          access: true,
          active: true,
          icon: "planlist",
          key: "planSubscription",
          path: "planSubscription",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Plan List",
        },
        {
          access: true,
          active: true,
          icon: "paymentLog",
          key: "paymentLog",
          path: "paymentLog",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Payment Logs",
        },
        {
          access: true,
          active: true,
          icon: "form_question",
          key: "form_question_master",
          path: "form_question_master",
          subMenu: [],
          title: "Form Question Master",
        },
        {
          access: true,
          active: true,
          icon: "massNotification",
          key: "massNotification",
          path: "massNotification",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Mass Notification",
        },
        {
          access: true,
          active: true,
          icon: "userLogs",
          key: "userPlanLog",
          path: "userPlanLog",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "User Logs",
        },
        {
          access: true,
          active: true,
          icon: "planlist",
          key: "couponList",
          path: "couponList",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [
            { name: "Tab 1", content: "Content for Tab 1" },
            { name: "Tab 2", content: "Content for Tab 2" },
          ],
          title: "Coupon List",
        },
        {
          access: true,
          active: true,
          icon: "email_campaign",
          key: "email_campaign",
          path: "email_campaign",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [],
          title: "Email Campaigns",
        },
        // NOTE: the sidebar renders `activeMenuList`, not `menuItem`, until a
        // group is clicked - and activeMenuList below is a hardcoded duplicate
        // of this Subscription submenu. Any entry added here MUST also be added there,
        // or it will not appear on first load.
        {
          access: true,
          active: false,
          icon: "massNotification",
          key: "coupon_assignment",
          path: "coupon_assignment",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          subMenu: [],
          tabs: [],
          title: "Coupon Assignment",
        },
      ],
    },
    {
      access: true,
      active: false,
      icon: "setting",
      title: "Settings",
      key: "settings",
      subMenu: [
        {
          access: true,
          active: false,
          icon: "terms",
          key: "update_terms_conditions",
          path: "update_terms_conditions",
          title: "Terms and Conditions",
        },
        {
          access: true,
          active: false,
          icon: "privacy",
          key: "update_privacy_policy",
          path: "update_privacy_policy",
          title: "Privacy Policy",
        },
        {
          access: true,
          active: false,
          icon: "password",
          key: "change_password",
          path: "change_password",
          title: "Change Password",
        },
        {
          access: true,
          active: false,
          icon: "terms",
          key: "app_pages",
          path: "app_pages",
          title: "App Pages",
        },
      ],
    },
  ],

  activeMenuList: [
    {
      access: true,
      active: true,
      icon: "dashboard",
      key: "dashboard",
      path: "dashboard",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [
        { name: "Tab 1", content: "Content for Tab 1" },
        { name: "Tab 2", content: "Content for Tab 2" },
      ],
      title: "Dashboard",
    },
    {
      access: true,
      active: true,
      icon: "people",
      key: "userList",
      path: "userList",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [
        { name: "Tab 1", content: "Content for Tab 1" },
        { name: "Tab 2", content: "Content for Tab 2" },
      ],
      title: "Users List",
    },
    {
      access: true,
      active: false,
      icon: "settings",
      key: "userquestion_history",
      path: "userquestion_history",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [
        { name: "Tab 1", content: "Content for Tab 1" },
        { name: "Tab 2", content: "Content for Tab 2" },
      ],
      title: "Users Question History",
    },
    {
      access: true,
      active: false,
      icon: "form_list",
      key: "user_form_list",
      path: "user_form_list",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [],
      title: "User Form List",
    },
    {
      access: true,
      active: false,
      icon: "user_metrics",
      key: "user_metrics",
      path: "user_metrics",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [],
      title: "User Metrics",
    },
    {
      access: true,
      active: false,
      icon: "list",
      key: "recommendation",
      path: "recommendation",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [],
      title: "User Preference Master",
    },
    {
      access: true,
      active: false,
      icon: "travel_type",
      key: "travel_types",
      path: "travel_types",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [],
      title: "User Travel Preference Master",
    },
    {
      access: true,
      active: false,
      icon: "master_tags",
      key: "master_tags",
      path: "master_tags",
      permission: {
        create: true,
        view: true,
        delete: true,
        edit: true,
      },
      subMenu: [],
      tabs: [],
      title: "Tag Master",
    },
  ],
  isSideBarCollapsed: false,
};

export const systemSlice = createSlice({
  name: "systemSlice",
  initialState,
  reducers: {
    setMenuItemData: (state, action) => {
      return {
        ...state,
        menuItem: action.payload,
      };
    },

    setActiveMenuList: (state, action) => {
      return {
        ...state,
        activeMenuList: action.payload,
      };
    },

    setIsSideBarCollapsed: (state, action) => {
      return {
        ...state,
        isSideBarCollapsed: action.payload,
      };
    },
  },
});

export const { setMenuItemData, setActiveMenuList, setIsSideBarCollapsed } =
  systemSlice.actions;

export const systemReducer = systemSlice.reducer;
